// SEQ-199 / SEQ-232: the grid's costs-entered rule, built ONLY from the By month
// table's own helpers (projectMonthCosts.ts): `buildProjectMonthTable` for the
// per-project month cells and `applyCostsEntered` for marking the flagged
// project months and taking them back out of each project's Total. Nothing of
// the rule is re-implemented here; this only reshapes the result for the grid.
//
// Pure TypeScript so a deno test can prove the seam the component sits on.

import type { PnlAnalyticsRow } from "../../lib/pnl/analyticsClient";
import { applyCostsEntered } from "./projectMonthCosts";
import { buildProjectMonthTable, type ProjectMonthProjectInfo } from "./projectMonthTable";
import type { GridProjectInput } from "./gridModel";

export interface GridCostsResult {
  /** The projects with each Total adjusted: flagged project months are taken back out of it unless `show`. */
  projects: GridProjectInput[];
  /** Per project, the months flagged "No costs entered". Absent for a project with none. */
  noCostMonths: Map<string, ReadonlySet<string>>;
}

export function applyGridCosts(
  months: string[],
  monthRows: PnlAnalyticsRow[],
  projects: ProjectMonthProjectInfo[],
  flagged: ReadonlySet<string>,
  show: boolean,
): GridCostsResult {
  const built = buildProjectMonthTable(months, monthRows, projects);
  const { table } = applyCostsEntered(built, flagged, show, months[0] ?? null);
  const noCostMonths = new Map<string, ReadonlySet<string>>();
  for (const row of table.rows) if (row.noCosts && row.noCosts.size > 0) noCostMonths.set(row.projectId, row.noCosts);
  return {
    projects: table.rows.map((r) => ({ projectId: r.projectId, projectName: r.projectName, status: r.status, total: r.total })),
    noCostMonths,
  };
}
